import React from "react";
import { ScrollReveal } from "./ScrollReveal";

export const SectionHeading = ({ eyebrow, title, subtitle, center = true }) => (
  <ScrollReveal className={center ? "text-center max-w-3xl mx-auto mb-14" : "max-w-3xl mb-14"}>
    {eyebrow && <div className="eyebrow mb-3">{eyebrow}</div>}
    <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight text-[#0F1E36]">{title}</h2>
    {subtitle && <p className="mt-4 text-base leading-relaxed text-[#627D98]">{subtitle}</p>}
  </ScrollReveal>
);

export default SectionHeading;
